module.exports = __webpack_public_path__ + "img/img_ksh.1830f3f6.gif";